export default __webpack_public_path__ + "static/media/ExcelFile.5453f73a.png";